<div *ngFor="let laderaum of laderaeume">
  <h1>{{ laderaum.label }}</h1>

  <table class="unterauftraege-table ansicht-phone">
    <tr *ngFor="let unterauftrag of laderaum.auftraege"
        [class.abgeschlossen]="unterauftrag.Auftragsstatus == 90"
        [class.abgelehnt]="unterauftrag.Auftragsstatus == 91"
        [class.volle-palette]="unterauftrag.istVollePalette">
  
      <td class="col-info1" appClick (clicked)="onUnterauftragClicked(unterauftrag)">{{ unterauftrag.stellplatzLkw}}</td>
      <td class="col-nummer" appClick (clicked)="onUnterauftragClicked(unterauftrag)">{{ unterauftrag.Info1}}</td>

      <td class="col-info2" appClick (clicked)="onUnterauftragClicked(unterauftrag)">
        {{ unterauftrag.Info2}}
        <div *ngIf="unterauftrag.status" class="palette-status-{{ unterauftrag.status }}">{{ unterauftrag.statusText }}</div>
  
        <div *ngIf="unterauftrag?.Zusatzdaten?.Hinweistext" class="hinweistext">{{ unterauftrag?.Zusatzdaten?.Hinweistext }}</div>
  
        <span class="voll-abgelehnt">Muss noch aus Lager geholt werden</span>
      </td>

      <td class="col-info3" appClick (clicked)="onUnterauftragClicked(unterauftrag)">{{ unterauftrag.Info3}}</td>
  
      <td class="col-zuweisen">
        <!-- Fertig -->
        <ion-icon *ngIf="unterauftrag.Auftragsstatus == 90"
                  name="checkmark"
                  class="auftragsstatus-90"></ion-icon>
      </td>
    </tr>
  </table>
</div>